// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3ERtk","colMaxWidth":"Table_colMaxWidth__2CBZG"};